import { usePostConsumerApplicationsV2PrequalificationsApplicationIdNextLenderMutation, usePatchConsumerApplicationsV2CreditApplicationsApplicationIdMutation, } from 'consumer-applications-v2-api';
const useAddtionalInfoEDS = () => {
    const [patchCreditApplication, { data: respPatchCreditApplication, isLoading: isLoadingPatchCreditApplication, },] = usePatchConsumerApplicationsV2CreditApplicationsApplicationIdMutation();
    const [postNextLender, { data: respNextLender, isLoading: isLoadingNextLender },] = usePostConsumerApplicationsV2PrequalificationsApplicationIdNextLenderMutation();
    return {
        patchCreditApplication,
        respPatchCreditApplication,
        isLoadingPatchCreditApplication,
        postNextLender,
        respNextLender,
        isLoadingNextLender,
    };
};
export default useAddtionalInfoEDS;
